import { Link } from "react-router-dom";
import { categories, navLinks } from "@/mocks/forecast";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-900 text-background-100">
      <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 gap-10 px-4 py-12 md:grid-cols-2 md:px-6 md:py-16 lg:grid-cols-4">
        <div className="lg:col-span-1">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50 font-heading text-xl font-bold text-primary-700">
              瓜
            </span>
            <span className="font-heading text-lg font-bold">看料大瓜</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-background-200">
            只整理公开可见的信号，把正在发酵的线索串成时间线，帮你在事件引爆前蹲好位置。
          </p>
          <div className="mt-5 flex items-center gap-3">
            <a
              href="#"
              aria-label="微信"
              rel="nofollow"
              className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-800 text-background-100 transition-colors hover:bg-primary-700"
            >
              <i className="ri-wechat-line" />
            </a>
            <a
              href="#"
              aria-label="微博"
              rel="nofollow"
              className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-800 text-background-100 transition-colors hover:bg-primary-700"
            >
              <i className="ri-weibo-line" />
            </a>
            <a
              href="#"
              aria-label="邮件订阅"
              rel="nofollow"
              className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-800 text-background-100 transition-colors hover:bg-primary-700"
            >
              <i className="ri-mail-send-line" />
            </a>
          </div>
        </div>

        <div>
          <h3 className="font-heading text-sm font-bold tracking-[0.2em] text-background-300">站内导航</h3>
          <ul className="mt-4 space-y-3 text-sm">
            {navLinks.map((link) => (
              <li key={link.to}>
                <Link to={link.to} className="text-background-100 transition-colors hover:text-accent-300">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-sm font-bold tracking-[0.2em] text-background-300">瓜田分类</h3>
          <ul className="mt-4 space-y-3 text-sm">
            {categories.map((cat) => (
              <li key={cat.id}>
                <Link
                  to={`/forecast?category=${cat.id}`}
                  className="text-background-100 transition-colors hover:text-accent-300"
                >
                  {cat.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-sm font-bold tracking-[0.2em] text-background-300">联系与线索</h3>
          <p className="mt-4 text-sm leading-relaxed text-background-200">
            有独家线索或内容纠错？欢迎来信，我们会逐条核实。
          </p>
          <a
            href="mailto:hello@kanliaodagua.example.com"
            className="mt-4 inline-flex items-center gap-2 rounded-md bg-background-50 px-4 py-2.5 text-sm font-semibold text-primary-800 transition-colors hover:bg-secondary-200"
          >
            <i className="ri-mail-line" />
            hello@kanliaodagua.example.com
          </a>
          <Link
            to="/#subscribe"
            className="mt-3 flex items-center gap-2 text-sm font-semibold text-accent-300 transition-colors hover:text-accent-200"
          >
            <i className="ri-notification-3-line" />
            订阅蹲守提醒
          </Link>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="mx-auto flex w-full max-w-[1280px] flex-col gap-3 px-4 py-5 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <p>© 2026 看料大瓜 · 内容基于公开信息整理，仅供信息参考。</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>理性吃瓜 · 尊重隐私</span>
            <span className="hidden h-3 w-px bg-primary-700 sm:block" />
            <span>站内内容不构成任何事实结论</span>
          </p>
        </div>
      </div>
    </footer>
  );
}